exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq-main-div{width:100%;display:flex;flex-direction:column;align-items:center}.faq-container{border-top:1px solid #ccc;border-left:1px solid #ccc;border-right:1px solid #ccc;text-align:left;padding:20px;width:70%;cursor:pointer}.faq-container:first-child{border-top:1px solid #ccc}.faq-container:last-child{border-bottom:1px solid #ccc}.faq-icon{width:10px;height:10px}.faq-icon-less{height:1px !important}.inquiry-container{display:flex;align-items:center;justify-content:space-between}.inquiry-header{font-weight:bold;margin:0}.inquiry-content{margin-top:10px}", ""]);

// exports
